import { observer } from 'mobx-react-lite';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import {
  Header,
  Segment,
  Image,
  Grid,
  Button,
  Step,
  Label,
  Dropdown,
} from 'semantic-ui-react';
import { Activity } from '../../../app/models/activity';
import AudioPlayer from 'react-h5-audio-player';
import { useStore } from '../../../app/stores/store';
import { Link, useParams } from 'react-router-dom';
import VideoPlayComponent from './VideoandAudioComponent/VideoPlayComponent';
import HistoryDetails from './HistoryDetails/HistoryDetails';
import TaskForm from './TaskForm';
import '../../../app/common/MediaQuery/responsive-view-page.css';
import MediaAssetResolveModal from '../../../app/common/modals/MediaAssetResolveModal';
import MicroLoaderViewPage from './VideoandAudioComponent/MicroTaggingDropdown/MicroLoaderViewPage';
import MediaAssetImage from '../MediaDashboard/MediaAssetImage';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import EditWorkflowModal from './EditWorkflowModal';
import MovementTracker from './HistoryDetails/MovementTracker';
import UserTracker from './HistoryDetails/UserTracker';
import ViewpageCreateOrder from '../Sections/ViewpageCreateOrder';
import TaskandSubTask from './TaskandSubTask';
import { WorkFlowTask } from '../../../app/models/template';
import agent from '../../../app/api/agent';
import { Task, activeOrderType, assignUserType } from '../../../app/api/types';

interface Props {
  activity: Activity;
}

export default observer(function ActivityDetailedHeader({ activity }: Props) {
  const {
    mediaAssetStore,
    dashboardStore,
    activityStore,
    commonStore,
    KanbanStore,
    userStore,
    TemplateStore,
    viewStore: {
      getItemDetails,
      assignedUsers,
      getUnAssignedUsersCount,
      unAssignedUsersCount,
      getUnAssignedUsersAlone,
      unAssignedUsers,
      addUserToItem,
      getAssignedUsers,
      removeUserFromItem,
      activeOrder,
      itemDetails,
    },
  } = useStore();

  const { id } = useParams<{ id: string }>();

  const [sortedListItems, setSortedListItems] = useState<activeOrderType>({
    templateId: '',
    templateIndex: 0,
    templateName: '',
    templateDateTime: '',
    isActive: false,
    isDeleted: false,
    tasks: [],
  });
  const [listTaskItems, setListTaskItems] = useState<Task[]>([]);
  const [activeIndexes, setActiveIndexes] = useState({
    task: 0,
    subTask: 0,
  });

  const tempListItemsTasks = useRef<WorkFlowTask[]>([]);

  const [assignUserList, setAssignUserList] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [removeUserList, setRemoveUserList] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [selectedAssignOptions, setSelectedAssignOptions] = useState<{
    userId: string;
    displayName: string;
  }>({ userId: '', displayName: '' });
  const [selectedRemoveOptions, setSelectedRemoveOptions] = useState<{
    userId: string;
    displayName: string;
  }>({ userId: '', displayName: '' });

  const noTemplate = useRef<boolean>(false);

  useEffect(() => {
    if (id) {
      getItemDetails({ itemId: id });
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    const filteredTemplate =
      TemplateStore?.selectedElementTypes?.templateTypes || [];
    if (filteredTemplate.length === 0) {
      noTemplate.current = true;
    } else {
      noTemplate.current = false;
    }
  }, [TemplateStore?.selectedElementTypes?.templateTypes]);

  useEffect(() => {
    TemplateStore.loadElementTypeById(activity?.elementtypeid);
    // eslint-disable-next-line
  }, [activity?.elementtypeid]);

  useEffect(() => {
    if (mediaAssetStore.mediaAsset.editworkflow === 'edit') {
      tempListItemsTasks.current = JSON.parse(JSON.stringify(listTaskItems));
    }
    // eslint-disable-next-line
  }, [mediaAssetStore.mediaAsset.editworkflow]);

  useEffect(() => {
    mediaAssetStore.showUserHistoryId(activity.id);
    setTimeout(() => {
      if (mediaAssetStore.mediaAsset.redirectOpenReject === true) {
        mediaAssetStore.mediaAsset.alertsResolveorRejectModalOpen = true;
      }
      if (mediaAssetStore.mediaAsset.redirectOpenResolved === true) {
        mediaAssetStore.mediaAsset.resolveValueSelected = true;
      }
    }, 1500);
  }, [mediaAssetStore, activity.id]);

  useEffect(() => {
    mediaAssetStore.editworkflowopen('cancel');
    KanbanStore.cardTriggerbtn = false;
    // eslint-disable-next-line
  }, []);

  const createOrderbtn = () => {
    mediaAssetStore.mediaAsset.isViewPageCreaterModalOpen = true;
    dashboardStore.openL3ForInventory('Create Order Receiving');
    // activityStore.CreateOrderItemApi(activity.id);
    dashboardStore.showClickedValueForAssetTable(activity.id);
  };

  useEffect(() => {
    //update remove user dropdown for mobile view
    if (window.innerWidth < 768) {
      let tempUsersList: { key: string; text: string; value: string }[] = [];
      assignedUsers?.forEach((data: assignUserType) => {
        tempUsersList.push({
          key: data.id,
          text: data.displayname,
          value: data.id,
        });
      });
      setRemoveUserList(tempUsersList);
    }
    // eslint-disable-next-line
  }, [assignedUsers]);

  useEffect(() => {
    if (window.innerWidth < 768) {
      getUnAssignedUsersCount({ itemId: activity.id, displayName: '' });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (window.innerWidth < 768 && unAssignedUsersCount !== 0) {
      getUnAssignedUsersAlone({
        itemId: activity.id,
        displayName: '',
        pageNo: 1,
        pageSize: unAssignedUsersCount,
      });
    }
    // eslint-disable-next-line
  }, [unAssignedUsersCount]);

  useEffect(() => {
    //update assign user dropdown for mobile view
    if (window.innerWidth < 768) {
      let tempUsersList: { key: string; text: string; value: string }[] = [];
      unAssignedUsers?.forEach((data: assignUserType) => {
        tempUsersList.push({
          key: data.id,
          text: data.displayname,
          value: data.id,
        });
      });
      setAssignUserList(tempUsersList);
    }
    // eslint-disable-next-line
  }, [unAssignedUsers]);

  const assignUser = (event: any, data: any) => {
    setSelectedAssignOptions({
      userId: data.value,
      displayName: event.currentTarget.innerText,
    });
  };

  const removeUser = (event: any, data: any) => {
    setSelectedRemoveOptions({
      userId: data.value,
      displayName: event.currentTarget.innerText,
    });
  };

  const handleSubmit = async () => {
    if (selectedAssignOptions.displayName !== '') {
      await addUserToItem(
        { itemId: activity?.id, userId: selectedAssignOptions.userId },
        selectedAssignOptions.displayName,
        false,
      );
      await getAssignedUsers({ itemId: activity?.id });
      await getUnAssignedUsersCount({ itemId: activity.id, displayName: '' });
      setSelectedAssignOptions({
        userId: '',
        displayName: '',
      });
    } else if (selectedRemoveOptions.displayName !== '') {
      await removeUserFromItem(
        { itemId: activity?.id, userId: selectedRemoveOptions.userId },
        selectedRemoveOptions.displayName,
      );
      await getAssignedUsers({ itemId: activity?.id });
      await getUnAssignedUsersCount({
        itemId: activity?.id,
        displayName: '',
      });
      activityStore.loadMovementHistory(selectedRemoveOptions.userId);
      activityStore.loadTimeDiff(selectedRemoveOptions.userId);
      setSelectedRemoveOptions({
        userId: '',
        displayName: '',
      });
    }
  };

  const activeTaskAndSubTaskHandler = async () => {
    let totalTaskCount = listTaskItems?.length || 0;
    let tasks = [...(listTaskItems || [])];
    let injectIndex: {
      task: number | null;
      subTask: number | null;
    } = {
      task: null,
      subTask: null,
    };
    let hasSetCurrentTask = false;
    let isCompleted = true;

    // --------------------- back track loop ------------------------- //
    for (let i = activeIndexes.task; i >= 0; i--) {
      for (let j = tasks?.[i]?.subTasks?.length - 1; j >= 0; j--) {
        if (tasks?.[i]?.status !== 'completed' && tasks?.[i]?.isActive) {
          if (
            tasks?.[i]?.subTasks?.[j]?.isCurrentSubtask &&
            tasks[i].subTasks[j].subTaskstatus !== 0 &&
            tasks[i].subTasks[j].parallelSubtaskId
          ) {
            hasSetCurrentTask = true;
            isCompleted = false;
            injectIndex = {
              task: i,
              subTask: j,
            };
            break;
          }
          if (
            tasks?.[i]?.subTasks?.[j]?.isActive &&
            tasks?.[i]?.subTasks?.[j]?.subTaskstatus === 0
          ) {
            hasSetCurrentTask = true;
            isCompleted = false;
            injectIndex = {
              task: i,
              subTask: j,
            };
          }
        }
      }
    }

    // --------------------- forward track loop ------------------------- //
    if (!hasSetCurrentTask) {
      let hasStopped = false;
      for (let i = activeIndexes.task; i < tasks?.length; i++) {
        if (hasStopped) break;
        for (let j = 0; j < tasks?.[i]?.subTasks?.length; j++) {
          if (hasStopped) break;
          if (tasks?.[i]?.status !== 'completed' && tasks?.[i]?.isActive) {
            if (
              tasks?.[i]?.subTasks?.[j]?.isCurrentSubtask &&
              tasks[i].subTasks[j].subTaskstatus !== 0
            ) {
              hasSetCurrentTask = true;
              isCompleted = false;
              injectIndex = {
                task: i,
                subTask: j,
              };
              hasStopped = true;
              break;
            }
            if (
              tasks?.[i]?.subTasks?.[j]?.isActive &&
              tasks?.[i]?.subTasks?.[j]?.subTaskstatus === 0
            ) {
              isCompleted = false;
              injectIndex = {
                task: i,
                subTask: j,
              };
              hasStopped = true;
              break;
            }
          }
        }
      }
    }

    if (injectIndex.task === null || injectIndex.subTask === null) {
      let taskI = tasks?.[tasks?.length - 1];
      return {
        tasks,
        isCompleted: true,
        taskId: taskI.taskId,
        subTaskId:
          taskI?.subTasks[taskI?.subTasks?.length - 1]?.subTaskId || '',
        totalTaskCount,
      };
    }

    // for (let i = 0; i < tasks?.length; i++) {
    //   if (injectIndex.task !== i) {
    //     tasks[i].isCurrentTask = false;
    //   }
    //   for (let j = 0; j < tasks?.length; j++) {
    //     if (injectIndex.task !== i) {
    //       if (injectIndex.subTask !== j && tasks[i]?.subTasks?.[j]) {
    //         tasks[i].subTasks[j].isCurrentSubtask = false;
    //       }
    //     }
    //   }
    // }

    // try {
    //   if (tasks?.[injectIndex.task]?.subTasks?.[injectIndex.subTask]) {
    //     tasks[injectIndex.task].subTasks[injectIndex.subTask].isCurrentSubtask =
    //       true;
    //     tasks[injectIndex.task].isCurrentTask = true;
    //   }
    // } catch {}

    setActiveIndexes({
      task: injectIndex.task,
      subTask: injectIndex.subTask,
    });

    return {
      tasks,
      isCompleted,
      taskId: tasks?.[tasks?.length - 1].taskId,
      subTaskId:
        tasks?.[tasks?.length - 1]?.subTasks[
          tasks?.[tasks?.length - 1]?.subTasks?.length - 1
        ]?.subTaskId || '',
      totalTaskCount,
    };
  };

  const saveHandler = async () => {
    let totalTaskActiveCount = 0;
    let totalCompleteTaskCount = 0;

    mediaAssetStore.mediaSaveLoader = true;
    if (
      JSON.stringify(tempListItemsTasks.current) ===
      JSON.stringify(listTaskItems)
    ) {
      toast.info('Please make changes to get it to save data');
      mediaAssetStore.mediaSaveLoader = false;
      return;
    }

    let sortedListItemsTemp = Object.assign({}, sortedListItems);

    let modifiedListItems = await activeTaskAndSubTaskHandler();

    // get total count and active and completed task details
    for (let i = 0; i < sortedListItemsTemp.tasks.length; i++) {
      if (sortedListItemsTemp.tasks[i].isActive) {
        let hasActiveTask = false;
        for (
          let j = 0;
          j < sortedListItemsTemp.tasks?.[i]?.subTasks?.length;
          j++
        ) {
          if (sortedListItemsTemp.tasks?.[i]?.subTasks?.[j]?.isActive) {
            hasActiveTask = true;
            break;
          }
        }

        // if (!hasActiveTask) {
        //   modifiedListItems.tasks[i].isActive = false;
        //   modifiedListItems.tasks[i].isCurrentTask = false;
        // }
        if (hasActiveTask) {
          totalTaskActiveCount += 1;
        }
      }
      if (modifiedListItems.tasks[i].status === 'completed') {
        totalCompleteTaskCount += 1;
      }
    }

    let tempTasks = modifiedListItems.tasks?.map((task) => {
      return {
        taskId: task.taskId,
        // templateTaskId: task.taskId,
        isActive: task.isActive,
        subTasks: task.subTasks?.map((subtask) => {
          return {
            subtaskId: subtask.subTaskId,
            // templateTaskId: subtask.templateSubtaskId,
            isActive: subtask.isActive,
          };
        }),
      };
    });

    if (modifiedListItems.isCompleted) {
      let promise = new Promise(async (resolve) => {
        await Promise.all([
          agent.workflowStatus.updateEditWorkflow(tempTasks, id || ''),
          agent.workflowStatus.updateWorkflowProductionCount({
            itemId: id || '',
            productionCount: 1,
            totalTaskCount: modifiedListItems.totalTaskCount || 0,
            totalTaskActiveCount: totalTaskActiveCount || 0,
            totalCompleteTaskCount: totalCompleteTaskCount || 0,
          }),
          agent.workflowStatus.updateIsReceiving({
            itemId: id || '',
          }),
          agent.workflowStatus.updateWorkflowInActive({
            itemId: id || '',
            templateId: sortedListItemsTemp.templateId,
            isActive: false,
          }),
        ]);
        resolve('');
      });
      promise.then(async () => {
        mediaAssetStore.mediaSaveLoader = false;
        getItemDetails({ itemId: activity.id });
        mediaAssetStore.mediaAsset.editworkflow = 'save';
      });
      promise.catch((error) => {
        mediaAssetStore.mediaSaveLoader = false;
        console.error(error);
      });
    } else {
      let p1 = new Promise(async (resolve) => {
        await Promise.all([
          agent.workflowStatus.updateEditWorkflow(tempTasks, id || ''),
          agent.workflowStatus.updateWorkflowProductionCount({
            itemId: id || '',
            productionCount: 0,
            totalTaskCount: modifiedListItems.totalTaskCount || 0,
            totalTaskActiveCount: totalTaskActiveCount || 0,
            totalCompleteTaskCount: totalCompleteTaskCount || 0,
          }),
        ]);
        resolve('');
      });
      p1.then(async () => {
        getItemDetails({ itemId: activity.id });
        mediaAssetStore.mediaSaveLoader = false;
        mediaAssetStore.mediaAsset.editworkflow = 'save';
      });
      p1.catch((error) => {
        mediaAssetStore.mediaSaveLoader = false;
        console.error(error);
      });
    }
  };

  //if second row of item page is disabled, then the first row should take up full view port height
  const segmentHeight =
    window.innerHeight -
    (document.querySelector('.lg-screen-taskform') as HTMLElement)
      ?.offsetHeight -
    120 +
    'px';

  return (
    <div className="adh">
      {mediaAssetStore.mediaAsset.resolveValueSelected && (
        <MediaAssetResolveModal />
      )}
      <Segment.Group
        style={{
          marginBottom:
            commonStore.filterModeTwo?.includes('SCB07') || noTemplate.current
              ? '0px'
              : '1rem',
          height:
            commonStore.filterModeTwo?.includes('AVLAVD03') &&
            commonStore.filterModeTwo?.includes('AVLAVB11') &&
            commonStore.filterModeTwo?.includes('AVLAVD02') &&
            window.innerWidth > 1200
              ? segmentHeight
              : 'auto',
        }}
      >
        <Segment
          className="adh-segment"
          attached="top"
          style={{ height: '100%' }}
        >
          {commonStore.filterModeTwo?.includes('AVLAVB16') ? (
            <>
              <Grid>
                <Grid.Row columns={2} className="adh-child-segment">
                  {(userStore.user?.customerName !== 'NFAI' ||
                    window.innerWidth > 1025 ||
                    window.innerWidth < 1020) && (
                    <Grid.Column
                      width={
                        window.innerWidth < 610
                          ? 16
                          : window.innerWidth < 767
                            ? 6
                            : 4
                      }
                    >
                      {itemDetails.thumbnail ? (
                        <Image
                          className="adh-thumbnail-small"
                          src={
                            commonStore.devEnv &&
                            itemDetails.thumbnail?.includes('build') &&
                            itemDetails.thumbnail?.includes('assets') &&
                            itemDetails.thumbnail?.includes('LocalStorage')
                              ? itemDetails.thumbnail?.split('build')?.[1]
                              : itemDetails.thumbnail
                          }
                          onError={(img: any) =>
                            (img.target.src = '/assets/thumbnail.png')
                          }
                        />
                      ) : (
                        <Image
                          className="adh-thumbnail-small"
                          src={'/assets/thumbnail.png'}
                        />
                      )}
                      {commonStore.filterModeTwo?.includes('AVLAVB01') ? (
                        <></>
                      ) : (
                        <Button
                          className="adh-button"
                          as={Link}
                          to={`/manage/${id}`}
                          color="orange"
                          disabled={commonStore.filterModeZero?.includes(
                            'AVLAVB01',
                          )}
                          //Manage Asset
                        >
                          {
                            (
                              userLanguage[0].AssetViewItemLevelAllAssetsView
                                .AVLAVB01 as any
                            )?.[`${commonStore.language.key}`]
                          }
                        </Button>
                      )}

                      {activity.current_task === 'Yet to Start' &&
                      activity.current_subtask === 'Yet to Start' ? (
                        <Label className="no_task">No Active Workflow</Label>
                      ) : (
                        <>
                          {commonStore.filterModeTwo?.includes('SCB07') ||
                          noTemplate.current ? (
                            <></>
                          ) : (
                            <div
                              className={
                                commonStore.filterModeZero?.includes('SCB07')
                                  ? 'sm-screen-taskform component-isDisabled'
                                  : 'sm-screen-taskform'
                              }
                            >
                              {activeOrder.templateId !== '' ? (
                                <TaskandSubTask
                                  activityId={activity.id}
                                  currentTask={activity.current_task}
                                />
                              ) : (
                                <Button
                                  color="teal"
                                  className="AHD-Workflow-button"
                                  onClick={createOrderbtn}
                                >
                                  Create Order
                                </Button>
                              )}
                            </div>
                          )}
                        </>
                      )}
                      {mediaAssetStore.mediaAsset.editworkflow !== 'edit' && (
                        <>
                          <EditWorkflowModal />
                        </>
                      )}
                      {commonStore.filterModeTwo?.includes('AVLAVD04') ? (
                        <></>
                      ) : (
                        <div
                          className={
                            commonStore.filterModeZero?.includes('AVLAVD04')
                              ? 'tracker-cta component-isDisabled'
                              : 'tracker-cta'
                          }
                        >
                          {userStore?.user?.customerName !== 'Museum' && (
                            <MovementTracker />
                          )}
                          <UserTracker />
                        </div>
                      )}

                      {mediaAssetStore.mediaAsset.editworkflow === 'edit' ? (
                        <Button.Group className="adh-cancel-save">
                          <Button
                            disabled={mediaAssetStore.mediaSaveLoader}
                            onClick={() =>
                              mediaAssetStore.editworkflowopen('close')
                            }
                          >
                            Cancel
                          </Button>
                          <Button.Or />
                          <Button
                            positive
                            loading={mediaAssetStore.mediaSaveLoader}
                            onClick={saveHandler}
                          >
                            Save
                          </Button>
                        </Button.Group>
                      ) : null}
                      {commonStore.filterModeTwo?.includes('AVLAVD02') ? (
                        <></>
                      ) : (
                        <div
                          className={
                            commonStore.filterModeZero?.includes('AVLAVD02')
                              ? 'component-isDisabled border assign-user-mobile'
                              : 'border assign-user-mobile'
                          }
                        >
                          {commonStore.filterModeTwo?.includes('AVLAVB09') ? (
                            <></>
                          ) : (
                            <Dropdown
                              options={assignUserList}
                              placeholder={
                                assignUserList.length === 0
                                  ? '--No Users--'
                                  : 'Assign Users'
                              }
                              Search
                              selection
                              clearable
                              onChange={(_event: any, data: any) =>
                                assignUser(_event, data)
                              }
                              value={selectedAssignOptions.userId}
                              disabled={
                                selectedRemoveOptions.displayName !== '' ||
                                assignUserList.length === 0 ||
                                commonStore.filterModeZero?.includes('AVLAVB09')
                              }
                            />
                          )}
                          {commonStore.filterModeTwo?.includes('AVLAVB10') ? (
                            <></>
                          ) : (
                            <Dropdown
                              options={removeUserList}
                              placeholder={
                                removeUserList.length === 0
                                  ? '--No Users--'
                                  : 'Remove User'
                              }
                              Search
                              selection
                              clearable
                              onChange={(_event: any, data: any) =>
                                removeUser(_event, data)
                              }
                              disabled={
                                selectedAssignOptions.displayName !== '' ||
                                removeUserList.length === 0 ||
                                commonStore.filterModeZero?.includes('AVLAVB10')
                              }
                              value={selectedRemoveOptions.userId}
                            />
                          )}
                          <Button positive onClick={handleSubmit}>
                            {
                              (userLanguage[0].AllocateUser?.AUB02 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                          </Button>
                        </div>
                      )}
                    </Grid.Column>
                  )}
                  <Grid.Column
                    width={
                      window.innerWidth < 610
                        ? 16
                        : window.innerWidth < 767
                          ? 10
                          : 12
                    }
                  >
                    <HistoryDetails />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </>
          ) : (
            <VideoPlayComponent
              preview={activity?.preview || ''}
              proxy={activity?.proxy}
            />
          )}
          {commonStore.filterModeOne?.includes('AVLAVB16') &&
          mediaAssetStore.mediaAsset.showMediaAssetTitle ? (
            <div>
              <Header size="large" content={activity.title} />
            </div>
          ) : null}
          {
            (userStore?.user?.customerName === 'Museum' ||
              userStore.user?.customerName === 'Isha Foundation') && (
              <>
                {activityStore.selectedActivity?.metadata?.map((metData) => {
                  return (
                    <>
                      {metData.elementName === 'Music Audio' && (
                        <Grid.Row>
                          <Grid.Column width={16} style={{ margin: '16px 0' }}>
                            <AudioPlayer src={metData.elementValue} />
                          </Grid.Column>
                        </Grid.Row>
                      )}
                    </>
                  );
                })}
              </>
            )
            // activityStore?.selectedActivity?.id ===
            //   '25396a95-ff2b-4eb4-9d52-12f58d381c4a' && (
            //   <Grid.Row>
            //     <Grid.Column width={16} style={{ margin: '16px 0' }}>
            //       <AudioPlayer src="../assets/Tabla_Baya_Sample_audio.mp3" />
            //     </Grid.Column>
            //   </Grid.Row>
          }
          {commonStore.filterModeOne?.includes('AVLAVB16') &&
            activityStore.peopleData && (
              <MicroLoaderViewPage id={activity.id} />
            )}
        </Segment>
        {commonStore.filterModeOne?.includes('AVLAVB16') ? (
          <>
            <Grid columns={1}>
              <Grid.Row>
                <MediaAssetImage />
              </Grid.Row>
            </Grid>
          </>
        ) : null}
      </Segment.Group>
      <div className="lg-screen-taskform">
        {commonStore.filterModeTwo?.includes('SCB07') || noTemplate.current ? (
          <></>
        ) : commonStore.filterModeOne?.includes('SCB07') ? (
          // activity.assignedUsers !== undefined &&
          activeOrder.templateId !== '' ? (
            <TaskForm
              sortedListItems={sortedListItems}
              setSortedListItems={setSortedListItems}
              listTaskItems={listTaskItems}
              setListTaskItems={setListTaskItems}
              activeIndexes={activeIndexes}
              setActiveIndexes={setActiveIndexes}
              activityId={activity.id}
            />
          ) : (
            <Step.Group
              attached="bottom"
              className="workflow-task-overflow"
              style={{ width: '100%', overflowY: 'scroll' }}
            >
              <Step>
                <Step.Content>
                  <Step.Title>
                    {
                      (
                        userLanguage[0]
                          .AssetsViewItemLevelViewPageWorkflowStepper
                          .AVILVPWSL01 as any
                      )?.[`${commonStore.language.key}`]
                    }
                    , &nbsp;&nbsp;{' '}
                    <span
                      className="AHD-Workflow-button"
                      onClick={createOrderbtn}
                    >
                      Create Order
                    </span>
                  </Step.Title>
                </Step.Content>
              </Step>
            </Step.Group>
          )
        ) : (
          <Step.Group
            attached="bottom"
            className="workflow-task-overflow"
            style={{ width: '100%', overflowY: 'scroll' }}
          >
            <Step>
              <Step.Content>
                <Step.Title>
                  Sorry ! You are not permitted to access the workflow.
                </Step.Title>
              </Step.Content>
            </Step>
          </Step.Group>
        )}
      </div>
      {mediaAssetStore.mediaAsset.isViewPageCreaterModalOpen && (
        <div>
          <ViewpageCreateOrder />
        </div>
      )}
    </div>
  );
});
